/*
 * «Дневник сна» радионяни: журнал ночей в браузере и выдача PDF.
 *
 *   • Recorder — пишет ночь из шагов детектора: громкость по минутам (самая
 *     громкая секунда минуты), эпизоды шума (звук выше порога, паузы < 20 с
 *     склеиваются), обрывы связи, колыбельные, «говорить». Минута, за которую
 *     не было ни одного шага (страница спала), остаётся -1 — «данных нет».
 *   • Журнал ведут ОБЕ стороны: детский блок слышит комнату всю ночь и раз в
 *     минуту шлёт свой снимок слушателям; слушатель хранит и свой, и его. В
 *     дневник идёт журнал детского блока, если он покрывает ночь, — иначе свой.
 *   • Хранилище — этот браузер (localStorage, до 14 ночей, не старше 60 дней).
 *     На сервер журнал уходит только в запрос сборки PDF и там не остаётся
 *     (config/baby-sleep-diary.php).
 *
 * API: window.BabySleepDiary — {Recorder, begin, tick, lost, lullaby, talkStart,
 * talkEnd, babyLog, setThreshold, end, flush, nights, summary, payload, issue,
 * name, setName}. Формат журнала проверяет App\Services\BabyMonitor\SleepDiary.
 */
(function () {
    'use strict';

    var KEY = 'bm-nights-v1';
    var NAME_KEY = 'bm-diary-name';
    var KEEP = 14;
    var MAX_AGE_MS = 60 * 86400 * 1000;
    var MAX_NIGHTS = 7;
    var MIN_SEC = 600;
    var MAX_MIN = 960;
    var MAX_EP = 400;
    var MAX_SPANS = 200;
    var CONTINUE_MS = 30 * 60 * 1000;
    var MERGE_GAP_S = 20;
    var CLOSE_QUIET_S = 8;
    var FLUSH_MS = 30 * 1000;
    var TYPE = { cry: 'c', speech: 's', whitenoise: 'w' };
    var SOUNDS = ['rain', 'ocean', 'heartbeat', 'shush', 'whitenoise', 'lullaby'];

    /* ── одна ночь ─────────────────────────────────────────────────────── */

    function Recorder(startMs, thrPct) {
        this.s = Math.floor(startMs / 1000);
        this.last = startMs;
        this.thr = thrPct || 23;
        this.m = [];
        this.ep = [];
        this.lostSpans = [];
        this.lul = [];
        this.talk = [];
        this.cur = null;
        this.talkAt = 0;
    }

    Recorder.fromSnapshot = function (snap, thrPct) {
        var r = new Recorder(snap.s * 1000, thrPct);
        r.last = snap.e * 1000;
        r.m = (snap.m || []).slice();
        r.ep = (snap.ep || []).slice();
        r.lostSpans = (snap.lost || []).slice();
        r.lul = (snap.lul || []).slice();
        r.talk = (snap.talk || []).slice();
        return r;
    };

    Recorder.prototype.sec = function (ms) { return Math.max(0, Math.round(ms / 1000 - this.s)); };

    Recorder.prototype.setThreshold = function (pct) {
        if (pct > 0 && pct < 100) this.thr = pct;
    };

    /**
     * Шаг детектора: уровень 0..100 (средний спектр к 128), тип звука и — когда он
     * меняется на ходу (колыбельная поднимает порог, как у сигнала шума) — порог.
     */
    Recorder.prototype.tick = function (pct, type, now, thrPct) {
        if (thrPct > 0 && thrPct < 100) this.thr = thrPct;
        var sec = now / 1000 - this.s;
        if (sec < 0) return;
        var mi = Math.floor(sec / 60);
        if (mi >= MAX_MIN) return;
        var lv = Math.max(0, Math.min(100, Math.round(pct)));
        while (this.m.length <= mi) this.m.push(-1);
        this.m[mi] = Math.max(this.m[mi] < 0 ? 0 : this.m[mi], lv);
        this.last = now;

        var t = Math.round(sec);
        var c = this.cur;
        if (lv > this.thr) {
            if (!c) c = this.cur = { t0: t, t1: t, peak: lv, ty: {}, qs: 0 };
            c.t1 = t;
            c.peak = Math.max(c.peak, lv);
            var k = TYPE[type] || 'n';
            c.ty[k] = (c.ty[k] || 0) + 1;
            c.qs = 0;
        } else if (c) {
            if (lv <= this.thr * 0.6) {
                if (!c.qs) c.qs = t;
                if (t - c.qs >= CLOSE_QUIET_S) this.close();
            } else {
                c.qs = 0;
            }
        }
    };

    Recorder.prototype.close = function () {
        var c = this.cur;
        if (!c) return;
        this.cur = null;
        var type = 'n', best = 0;
        /* «Похоже на плач» побеждает, если в эпизоде он был хотя бы в четверти
         * шагов: плач перемежается вдохами, которые классификатор зовёт шумом. */
        var total = 0;
        Object.keys(c.ty).forEach(function (k) { total += c.ty[k]; });
        if ((c.ty.c || 0) >= total * 0.25 && c.ty.c) type = 'c';
        else Object.keys(c.ty).forEach(function (k) { if (c.ty[k] > best) { best = c.ty[k]; type = k; } });
        var prev = this.ep[this.ep.length - 1];
        if (prev && c.t0 - prev[1] < MERGE_GAP_S) {
            prev[1] = Math.max(prev[1], c.t1);
            prev[2] = Math.max(prev[2], c.peak);
            if (type === 'c') prev[3] = 'c';
            return;
        }
        if (this.ep.length < MAX_EP) this.ep.push([c.t0, c.t1, c.peak, type]);
    };

    Recorder.prototype.lost = function (fromMs, toMs) {
        if (this.lostSpans.length >= MAX_SPANS) return;
        var a = this.sec(fromMs), b = this.sec(toMs);
        if (b > a) this.lostSpans.push([a, b]);
    };

    Recorder.prototype.lullaby = function (sound, now) {
        if (SOUNDS.indexOf(sound) < 0 || this.lul.length >= MAX_SPANS) return;
        this.lul.push([this.sec(now), sound]);
    };

    Recorder.prototype.talkStart = function (now) { this.talkAt = now; };
    Recorder.prototype.talkEnd = function (now) {
        if (!this.talkAt || this.talk.length >= MAX_SPANS) { this.talkAt = 0; return; }
        this.talk.push([this.sec(this.talkAt), Math.max(0, Math.min(3600, Math.round((now - this.talkAt) / 1000)))]);
        this.talkAt = 0;
    };

    /** Снимок: открытый эпизод входит как есть — ночь могла кончиться посреди плача. */
    Recorder.prototype.snapshot = function () {
        var ep = this.ep.slice();
        var c = this.cur;
        if (c && ep.length < MAX_EP) ep.push([c.t0, c.t1, c.peak, (c.ty.c ? 'c' : 'n')]);
        return {
            s: this.s, e: Math.max(this.s + 1, Math.floor(this.last / 1000)),
            m: this.m.slice(0, MAX_MIN), ep: ep, lost: this.lostSpans.slice(), lul: this.lul.slice(), talk: this.talk.slice()
        };
    };

    /* ── хранилище ─────────────────────────────────────────────────────── */

    function load() {
        try {
            var v = JSON.parse(localStorage.getItem(KEY) || '[]');
            return Array.isArray(v) ? v.filter(function (n) { return n && n.own && n.own.s; }) : [];
        } catch (e) { return []; }
    }

    function save(list) {
        var now = Date.now();
        list = list.filter(function (n) { return now - n.own.e * 1000 < MAX_AGE_MS; })
            .sort(function (a, b) { return a.own.s - b.own.s; })
            .slice(-KEEP);
        try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {
            /* Переполнение: старшая ночь уступает место текущей. */
            try { localStorage.setItem(KEY, JSON.stringify(list.slice(-Math.max(1, Math.floor(list.length / 2))))); } catch (e2) {}
        }
    }

    function upsert(night) {
        var list = load();
        var i = -1;
        list.forEach(function (n, k) { if (n.id === night.id) i = k; });
        if (i >= 0) list[i] = night; else list.push(night);
        save(list);
    }

    /* ── текущая ночь этой страницы ─────────────────────────────────────── */

    var cur = null;
    var lastFlush = 0;

    /**
     * Начать (или продолжить) ночь. Та же комната и меньше 30 минут с последней
     * записи — это та же ночь: страница перезагрузилась, связь восстановилась.
     */
    function begin(room, thrPct) {
        var now = Date.now();
        room = String(room || '');
        if (cur && cur.night.room === room) { cur.rec.setThreshold(thrPct); return; }
        if (cur) flush();
        var list = load();
        var last = list[list.length - 1];
        if (last && last.room === room && now - last.own.e * 1000 < CONTINUE_MS) {
            cur = { night: last, rec: Recorder.fromSnapshot(last.own, thrPct) };
        } else {
            cur = { night: { id: String(room) + ':' + now, room: String(room), own: null, baby: null }, rec: new Recorder(now, thrPct) };
        }
        flush();
    }

    function flush() {
        if (!cur) return;
        cur.night.own = cur.rec.snapshot();
        cur.night.t = Date.now();
        upsert(cur.night);
        lastFlush = Date.now();
    }

    function tick(pct, type, thrPct) {
        if (!cur) return;
        var now = Date.now();
        cur.rec.tick(pct, type, now, thrPct);
        if (now - lastFlush > FLUSH_MS) flush();
    }

    function validSnap(s) {
        return s && typeof s.s === 'number' && typeof s.e === 'number' && s.e > s.s
            && Array.isArray(s.m) && Array.isArray(s.ep) && s.m.length <= MAX_MIN + 2 && s.ep.length <= MAX_EP;
    }

    /** Снимок журнала детского блока — он слышал комнату и когда этот телефон нет. */
    function babyLog(snap) {
        if (!cur || !validSnap(snap)) return;
        cur.night.baby = {
            s: snap.s | 0, e: snap.e | 0,
            m: snap.m.map(function (v) { v = v | 0; return v < -1 ? -1 : v > 100 ? 100 : v; }),
            ep: snap.ep.slice(0, MAX_EP), lul: Array.isArray(snap.lul) ? snap.lul.slice(0, MAX_SPANS) : []
        };
    }

    function end() { flush(); cur = null; }

    /* ── ночи для экрана и для дневника ─────────────────────────────────── */

    /** Источник ночи: журнал детского блока, если он покрывает хотя бы половину. */
    function chosen(n) {
        var own = n.own, b = n.baby;
        if (b && (b.e - b.s) >= 0.5 * (own.e - own.s) && (b.e - b.s) >= MIN_SEC) return { src: 'b', j: b };
        return { src: 'p', j: own };
    }

    function countEp(ep) {
        var cry = 0;
        ep.forEach(function (x) { if (x[3] === 'c') cry++; });
        return { episodes: ep.length, cry: cry };
    }

    function summary(n) {
        var c = chosen(n);
        var k = countEp(c.j.ep);
        return { id: n.id, s: c.j.s, e: c.j.e, dur: c.j.e - c.j.s, src: c.src, episodes: k.episodes, cry: k.cry };
    }

    function nights() {
        return load().filter(function (n) { var c = chosen(n); return c.j.e - c.j.s >= MIN_SEC; })
            .sort(function (a, b) { return chosen(a).j.s - chosen(b).j.s; });
    }

    /* Отпечаток журнала (FNV-1a): «этот дневник уже получен» без хранения его копии. */
    function fingerprint(str) {
        var h = 0x811c9dc5;
        for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0; }
        return h.toString(16);
    }
    var GOT_KEY = 'bm-diary-got';
    function got() {
        try { return localStorage.getItem(GOT_KEY) === fingerprint(payload()); } catch (e) { return false; }
    }
    function markGot(body) {
        try { localStorage.setItem(GOT_KEY, fingerprint(body)); } catch (e) {}
    }

    function shift(list, from, to, dur, withLen) {
        var out = [];
        (list || []).forEach(function (x) {
            var a = x[0] + from - to;
            if (a < 0 || a > dur) return;
            out.push(withLen ? [a, Math.max(a, Math.min(dur, x[1] + from - to))] : [a, x[1]]);
        });
        return out;
    }

    /** Журнал для сборки: последние до 7 ночей. Строка — ровно то, что уйдёт на сервер. */
    function payload() {
        var list = nights().slice(-MAX_NIGHTS).map(function (n) {
            var c = chosen(n), j = c.j, own = n.own;
            var dur = j.e - j.s;
            var night = { s: j.s, e: j.e, src: c.src, m: j.m.slice(0, Math.floor(dur / 60) + 1), ep: j.ep.slice(0, MAX_EP) };
            if (c.src === 'b') {
                /* Обрывы связи телефона детской не касались — тишину они не съедают. */
                night.lost = [];
                night.lul = (j.lul || []).slice(0, MAX_SPANS);
                night.talk = shift(own.talk, own.s, j.s, dur, false).slice(0, MAX_SPANS);
            } else {
                night.lost = (own.lost || []).slice(0, MAX_SPANS);
                night.lul = (own.lul || []).slice(0, MAX_SPANS);
                night.talk = (own.talk || []).slice(0, MAX_SPANS);
            }
            return night;
        });
        return JSON.stringify({ v: 1, tz: new Date().getTimezoneOffset(), name: name(), nights: list });
    }

    function name() {
        try { return (localStorage.getItem(NAME_KEY) || '').slice(0, 40); } catch (e) { return ''; }
    }

    function setName(v) {
        try { localStorage.setItem(NAME_KEY, String(v || '').slice(0, 40)); } catch (e) {}
    }

    /* ── выдача PDF (карточка <x-perk-gate perk="baby_sleep_diary">) ───────── */

    function csrf() {
        var m = document.querySelector('meta[name="csrf-token"]');
        return m ? m.getAttribute('content') : '';
    }

    /* ⚠️ Гостю страница приходит из кэша с ЧУЖИМ токеном и без сессионной куки —
     * ждём общий __csrfReady() (так же делает dementia-report.js). */
    function send(url, opts) {
        var ready = (typeof window.__csrfReady === 'function') ? window.__csrfReady() : Promise.resolve(null);
        return ready.then(function () {
            opts.credentials = 'same-origin';
            if (opts.method === 'POST') opts.headers['X-CSRF-TOKEN'] = csrf();
            return fetch(url, opts);
        });
    }

    function getJson(url) {
        return send(url, { method: 'GET', cache: 'no-store', headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json().catch(function () { return {}; }); })
            .catch(function () { return {}; });
    }

    /* ── право за рубли (касса документов, только рублёвые локали) ────────────
     * Номер и ключ права заводятся при первом признаке намерения купить (park),
     * касса их оплачивает, а дневник собирается по журналу этого браузера.
     * Право привязывается к журналу при первой удачной сборке: тот же журнал —
     * ещё раз без оплаты, новые ночи — новый дневник (как и за токены). */
    var PASS_KEY = 'bm-diary-pass';
    var PASS_STALE_MS = 20 * 864e5;   // неоплаченное право сервер держит 30 дней
    var parking = null;

    function pass() {
        try {
            var p = JSON.parse(localStorage.getItem(PASS_KEY) || 'null');
            return p && p.ref && p.token !== undefined ? p : null;
        } catch (e) { return null; }
    }
    function setPass(p) {
        try {
            if (p) localStorage.setItem(PASS_KEY, JSON.stringify(p));
            else localStorage.removeItem(PASS_KEY);
        } catch (e) {}
    }
    /** Право, которым можно оплатить ЭТОТ журнал: ещё не привязанное или привязанное к нему. */
    function passFor(body) {
        var p = pass();
        return p && (!p.fp || p.fp === fingerprint(body)) ? p : null;
    }
    /** Оплачено, а дневник по нему ещё не собран — карточке платить нечего. */
    function paidWaiting() {
        var p = pass();
        return !!(p && p.paid && !p.fp);
    }

    function park() {
        var p = pass();
        if (p && !p.fp && (p.paid || Date.now() - (p.at || 0) < PASS_STALE_MS)) {
            return Promise.resolve({ ref: p.ref, token: p.token });
        }
        if (parking) return parking;
        var mine = parking = send('/api/baby-monitor/sleep-diary/pass', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ locale: window.__LOCALE || 'en' })
        }).then(function (r) { return r.json(); }).then(function (j) {
            if (parking === mine) parking = null;
            if (!j || !j.ok) return null;
            setPass({ ref: j.ref, token: j.token, at: Date.now() });
            return { ref: j.ref, token: j.token };
        }).catch(function () { if (parking === mine) parking = null; return null; });
        return mine;
    }

    /** Право из письма или возврата кассы: номер (и ключ, если пришёл) — в этот браузер. */
    function adopt(ref, token) {
        var p = pass();
        if (p && +p.ref === +ref) {
            if (token && !p.token) { p.token = token; setPass(p); }
            return p;
        }
        p = { ref: +ref, token: token || '', at: Date.now() };
        setPass(p);
        return p;
    }

    function status(ref, token) {
        return getJson('/api/baby-monitor/sleep-diary/pass?ref=' + encodeURIComponent(ref)
            + '&token=' + encodeURIComponent(token || ''))
            .then(function (j) {
                var p = pass();
                if (j && j.ok && p && +p.ref === +ref) {
                    p.paid = !!j.paid;
                    setPass(p);
                }
                return j || {};
            });
    }

    /** `?bsd_paid=<право>` (возврат из кассы) или `…&bsd_key=` (письмо). Адрес чистится сразу. */
    function paidReturn() {
        var q = window.location.search || '';
        var m = /[?&]bsd_paid=(\d+)/.exec(q);
        if (!m) return null;
        var km = /[?&]bsd_key=([A-Za-z0-9-]{8,64})/.exec(q);
        try {
            var clean = window.location.pathname
                + q.replace(/([?&])bsd_(paid|key)=[^&]*/g, '$1').replace(/[?&]+$/, '').replace(/\?&+/, '?').replace(/&&+/g, '&');
            window.history.replaceState({}, '', clean + window.location.hash);
        } catch (e) {}
        return { ref: +m[1], key: km ? km[1] : '' };
    }

    /**
     * Собрать дневник. opts.claim — забрать оплаченное деньгами (возврат из кассы,
     * письмо): тогда право — единственная дверь, и сервер не уведёт сборку в токены.
     */
    function issue(opts) {
        opts = opts || {};
        var body = payload();
        if (!JSON.parse(body).nights.length) return Promise.resolve({ ok: false, error: 'no_nights' });
        var p = passFor(body);
        var req = { payload: body, locale: window.__LOCALE || 'en' };
        if (p) { req.ref = p.ref; req.token = p.token || ''; }
        if (p && opts.claim) req.claim = 1;
        return send('/api/baby-monitor/sleep-diary', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/pdf, application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(req)
        }).then(function (r) {
            var type = r.headers.get('Content-Type') || '';
            if (r.ok && type.indexOf('application/pdf') === 0) {
                var cd = r.headers.get('Content-Disposition') || '';
                var m = /filename\*=UTF-8''([^;]+)/i.exec(cd) || /filename="?([^";]+)"?/i.exec(cd);
                var nm = m ? decodeURIComponent(m[1]) : 'sleep-diary.pdf';
                var via = r.headers.get('X-Diary-Via') || '';
                return r.blob().then(function (b) {
                    markGot(body);
                    if (p && (via === 'money' || via === 'repeat')) { p.fp = fingerprint(body); p.paid = true; setPass(p); }
                    return { ok: true, blob: b, name: nm, via: via, nights: JSON.parse(body).nights.length };
                });
            }
            return r.json().catch(function () { return {}; }).then(function (j) {
                var err = (j && j.error) || ('http_' + r.status);
                // Право сервер не узнал (срок вышел, чужой ключ) — завтра заведём новое.
                if (p && r.status === 404 && err === 'not_found') setPass(null);
                return { ok: false, error: err, status: r.status };
            });
        }).catch(function () { return { ok: false, error: 'network', status: 0 }; });
    }

    window.BabySleepDiary = {
        Recorder: Recorder,
        begin: begin, tick: tick, flush: flush, end: end, babyLog: babyLog,
        lost: function (a, b) { if (cur) cur.rec.lost(a, b); },
        lullaby: function (sound) { if (cur) cur.rec.lullaby(sound, Date.now()); },
        talkStart: function () { if (cur) cur.rec.talkStart(Date.now()); },
        talkEnd: function () { if (cur) cur.rec.talkEnd(Date.now()); },
        setThreshold: function (pct) { if (cur) cur.rec.setThreshold(pct); },
        active: function () { return !!cur; },
        nights: nights, summary: summary, payload: payload, issue: issue, got: got,
        park: park, pass: pass, adopt: adopt, status: status, paidReturn: paidReturn, paidWaiting: paidWaiting,
        name: name, setName: setName,
        _load: load, _save: save
    };

    if (typeof module !== 'undefined' && module.exports) module.exports = window.BabySleepDiary;
})();
